import { UserRoles } from "constants/userRoles";
import { UserWorkspaceProfile } from "models/UserWorkspaceProfile";

export const initialUserWorkspaceState: UserWorkspaceProfile = {
    id: '',
    displayName: '',
    profilePhotoUrl: undefined,
    role: UserRoles.Participant,
    email: '',
    emailConfirmed: false,
    hasLessons: false,
    hasSubordinates: false,
    workspace: {
        id: '',
        name: '',
    },
    patrons: [],
}